

/**
 * Mutación para guardar los informes procesados
 *
 * @export
 * @param {*} state
 * @param {*} informes
 */
export function setInformesProcesados(state, informes) {
    state.informesProcesados = informes;
}

/**
 * Mutación para guardar la ruta del archivo a descargar
 *
 * @export
 * @param {*} state
 * @param {*} informe
 */
export function setInforme(state, informe) {
    state.informe = informe.data;
}

/**
 * Mutación para limpiar filtro de registros de accesos
 *
 * @export
 * @param {*} state
 * @param {*} informe
 */
export function clearFilterAccess(state) {
    state.selectedEmpresa.id =  ''
    state.filtrosBusqueda.fecha =  null
}
